import { Component, Host, h, Prop, State, Element, Event, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-textarea',
  styleUrl: 'cobalt-textarea.css'
})
export class CobaltTextarea {
  /**
   * The label that accompany the textarea field.
   */
  @Prop({ mutable: true }) label!: string
  /**
   * Description is available on `outside` and `aside` format and will append below the label.
   */
  @Prop({ mutable: true }) description?: string
  /**
   * Placeholder inside the select.
   */
  @Prop({ mutable: true }) placeholder?: string
  /**
   * Mention displayed to indicate if the field is mandatory or optional. If none is selected `custom-requirement` slot is available.
   */
  @Prop({ mutable: true }) requirement?: 'mandatory' | 'optional' | 'none' = 'mandatory'
  /**
   * Position the label in different place.
   */
  @Prop({ mutable: true }) format?: 'outside' | 'aside' | 'hidden' = 'outside'
  /**
   * A boolean indicating the disable state of the textarea field. The `aria-disabled` attribute relies on this property.
   */
  @Prop({ mutable: true }) disabled?: boolean = false
  /**
   * Display an error message under the field and set the field in error state.
   */
  @Prop({ mutable: true }) errorMessage?: string = null
  /**
   * Corresponding to the value of the textarea field
   */
  @State() value: string
  /**
   * Emitted when the value has changed.
   */
  @Event() cobaltTextareaValueChange: EventEmitter<string>

  @Element() element: HTMLElement

  handleValueChange = (): void => {
    if (this.disabled) return
    this.value = this.element.querySelector('textarea').value
    this.cobaltTextareaValueChange.emit(this.value)
  }

  render(): any {
    return (
      <Host>
        <core-textarea
          label={this.label}
          description={this.description}
          placeholder={this.placeholder}
          requirement={this.requirement}
          format={this.format}
          disabled={this.disabled}
          errorMessage={this.errorMessage}
          onCoreTextareaValueChange={this.handleValueChange}
        >
          {this.requirement === 'none' && <slot slot="custom-requirement" name="custom-requirement" />}
        </core-textarea>
      </Host>
    )
  }
}
